'use strict';

angular.module('app.home.timeline')
    .directive('homeTimelineDirective', function () {
        return {
            controller: 'HomeTimelineCtrl',
            templateUrl: 'app/home/homeTimeline/homeTimeline.html?app_v=deployDate',
            restrict: 'E',
            scope: {
                
            },
            replace: true,
            transclude: true
        };
    })